export default "__VITE_ASSET___NMgSEbC__"